import { useQuery } from '@tanstack/react-query';
import { StatusGroup, useCasesBoardStore } from '@/store/cases-board.store';
import {
  caseQueries,
  getCountByGroupSelector,
  getCountByStatusSelector,
  useBoardCountsQueryOptions,
} from '@/queries/case';
import { CaseStatus } from '@/api/apis/case';

export const useCasesBoardRowVisibility = () => {
  const hideEmpty = useCasesBoardStore((store) => store.hideEmpty);
  const { params, enabled } = useBoardCountsQueryOptions();

  const { data: counts } = useQuery({
    ...caseQueries.counts(params),
    enabled: hideEmpty && enabled,
  });

  const shouldRenderRow = !hideEmpty || !counts;

  return {
    shouldRenderStatus: (s: CaseStatus) => shouldRenderRow || getCountByStatusSelector(s)(counts) !== 0,
    shouldRenderGroup: (g: StatusGroup) => shouldRenderRow || getCountByGroupSelector(g)(counts) !== 0,
  };
};
